export default __webpack_public_path__ + "static/media/stanbic-secondary.272a9660.png";